import { render } from "./CardVideoThumbnail.vue?vue&type=template&id=0bc884ea"
import script from "./CardVideoThumbnail.vue?vue&type=script&lang=js"
export * from "./CardVideoThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__